import React from 'react';

function Rwanda(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124009)">
        <mask
          id="mask0_800_124009"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124009)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#FECA00"
          />
          <mask
            id="mask1_800_124009"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124009)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V14H36V0H0Z"
              fill="#3CA5D9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 18V24H36V18H0Z"
              fill="#5A962A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.092 11.8656C27.0547 11.8664 27.0173 11.8668 26.9797 11.8668C26.9476 11.8668 26.9156 11.8665 26.8836 11.8659L26.2036 13.8398L26.0598 11.7838C25.9909 11.7712 25.9226 11.7571 25.8549 11.7418L24.6773 13.5217L25.076 11.495C25.0118 11.4685 24.9485 11.4407 24.886 11.4117L23.2756 12.9027L24.1939 11.014C24.138 10.9749 24.0831 10.9347 24.0294 10.8934L22.074 12.0162L23.4605 10.3675C23.4158 10.3177 23.3724 10.2669 23.3303 10.2152L21.1373 10.9099L22.9152 9.58956C22.8844 9.53137 22.8552 9.4724 22.8275 9.41271L20.516 9.64357L22.5896 8.72047C22.575 8.65724 22.5621 8.59345 22.551 8.52916L20.2437 8.28534L22.5022 7.80787C22.5045 7.74254 22.5087 7.67762 22.5146 7.61313L20.3349 6.9085L22.6556 6.90187C22.6751 6.8386 22.6964 6.77596 22.7194 6.714L20.7847 5.58727L23.045 6.05146C23.0806 5.99413 23.1179 5.93767 23.1566 5.88211L21.569 4.39286L23.6483 5.30361C23.6977 5.25537 23.7485 5.20821 23.8006 5.16217L22.6454 3.38969L24.4309 4.69829C24.4913 4.66151 24.5529 4.62599 24.6154 4.5918L23.9559 2.63182L25.3508 4.2681C25.419 4.24474 25.4879 4.2228 25.5576 4.20233L25.4299 2.16011L26.3592 4.03743C26.4309 4.02871 26.5032 4.02147 26.5759 4.01576L26.9879 2L27.4001 4.01709C27.4724 4.023 27.5443 4.03043 27.6157 4.03933L28.5458 2.16011L28.4178 4.20706C28.4864 4.22746 28.5542 4.24926 28.6212 4.27245L30.0198 2.63182L29.3578 4.59936C29.4187 4.63291 29.4786 4.66772 29.5375 4.70373L31.3303 3.38969L30.1692 5.17135C30.2194 5.21605 30.2684 5.26179 30.3162 5.30855L32.4067 4.39286L30.8093 5.89138C30.8464 5.94491 30.882 5.99927 30.9163 6.05443L33.191 5.58727L31.2429 6.72183C31.2648 6.78122 31.2851 6.84123 31.3038 6.90182L33.6409 6.9085L31.4453 7.61826C31.4509 7.67991 31.4548 7.74197 31.4571 7.80439L33.7321 8.28534L31.4081 8.53092C31.3975 8.59238 31.3852 8.65338 31.3713 8.71388L33.4597 9.64357L31.1326 9.41115C31.1061 9.4684 31.0782 9.52498 31.0488 9.58085L32.8384 10.9099L30.6324 10.2111C30.592 10.261 30.5503 10.31 30.5073 10.3581L31.9018 12.0162L29.937 10.888C29.8849 10.9282 29.8318 10.9674 29.7777 11.0054L30.7002 12.9027L29.0843 11.4066C29.0232 11.4352 28.9612 11.4626 28.8985 11.4887L29.2984 13.5217L28.1187 11.7385C28.0518 11.7539 27.9843 11.768 27.9162 11.7807L27.7722 13.8398L27.092 11.8656ZM26.9393 10.4148C28.515 10.4148 29.7923 9.29592 29.7923 7.91568C29.7923 6.53544 28.515 5.41653 26.9393 5.41653C25.3636 5.41653 24.0863 6.53544 24.0863 7.91568C24.0863 9.29592 25.3636 10.4148 26.9393 10.4148ZM28.5803 7.98886C28.5803 8.77821 27.8604 9.4181 26.9724 9.4181C26.0844 9.4181 25.3645 8.77821 25.3645 7.98886C25.3645 7.19952 26.0844 6.55963 26.9724 6.55963C27.8604 6.55963 28.5803 7.19952 28.5803 7.98886Z"
              fill="#FFDC17"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124009">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Rwanda;
